import type { Theme } from '../styles/theme.js';
import { STRINGS } from '../strings.js';

type Props = {
  isOpen: boolean;
  unreadCount: number;
  onClick: () => void;
  theme: Theme;
};

export function FloatingButton({ isOpen, unreadCount, onClick, theme }: Props) {
  return (
    <button
      type="button"
      aria-label={isOpen ? STRINGS.buttonClose : STRINGS.buttonOpen}
      onClick={onClick}
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        width: '60px',
        height: '60px',
        borderRadius: '50%',
        backgroundColor: theme.brandColor,
        color: '#fff',
        border: 'none',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 999998,
        fontSize: '24px',
        transition: 'transform 0.15s ease',
      }}
      onMouseEnter={(e) => {
        (e.currentTarget as HTMLButtonElement).style.transform = 'scale(1.05)';
      }}
      onMouseLeave={(e) => {
        (e.currentTarget as HTMLButtonElement).style.transform = 'scale(1.0)';
      }}
    >
      {isOpen ? '×' : '💬'}
      {!isOpen && unreadCount > 0 && (
        <span
          aria-label={`${unreadCount} ${STRINGS.unreadBadgeLabel}`}
          style={{
            position: 'fixed',
            bottom: '64px',
            right: '14px',
            minWidth: '20px',
            height: '20px',
            padding: '0 5px',
            borderRadius: '10px',
            backgroundColor: '#d9534f',
            color: '#fff',
            fontSize: '11px',
            fontWeight: 700,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
            zIndex: 999999,
          }}
        >
          {unreadCount > 9 ? '9+' : unreadCount}
        </span>
      )}
    </button>
  );
}
